import React, { useState, useRef } from 'react'
import './Login.css'
import axios from 'axios'
import { Baseurl } from '../../Config/Baseurl'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import img from '../../assets/images/img.png'

export const Login2 = () => {
  const email = useRef()
  toast.configure()
  const navigate = useNavigate()

  // state to store vlaues
  const [data, setData] = useState({
    email: '',
    password: '',
    role: '',
    name: '',
  })

  // input onchange
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setData({ ...data, [name]: value })
  }

  // to show/hide password
  const [showPassword, setShowPassword] = useState(false)
  const onMouseDown = () => {
    setShowPassword(!showPassword)
  }

  //login Function
  const submit = async (e) => {
    e.preventDefault()

    await axios
      .post(Baseurl.nodeLocal + 'enduser/login', {
        email: data.email,
        password: data.password,
        role: data.role,
      })
      .then((response) => {
        //storing user details name,email,role in localstorage
        if (response.data.role === 'Admin') {
          localStorage.setItem('user', response.data.userName)
          localStorage.setItem('role', response.data.role)
          localStorage.setItem('id', response.data.id)
          localStorage.setItem('email', data.email)
          localStorage.setItem('token', response.data.token)
          navigate('/portal')
        } else if (response.data.role === 'HR') {
          localStorage.setItem('user', response.data.userName)
          localStorage.setItem('role', response.data.role)
          localStorage.setItem('id', response.data.id)
          localStorage.setItem('email', data.email)
          localStorage.setItem('token', response.data.token)
          navigate('/portal')
        } else if (response.data.role === 'Accounts') {
          localStorage.setItem('user', response.data.userName)
          localStorage.setItem('role', response.data.role)
          localStorage.setItem('id', response.data.id)
          localStorage.setItem('email', data.email)
          localStorage.setItem('token', response.data.token)
          navigate('/portal')
        }
      })
      .catch((error) => {
        if (error.response.status === 0) {
          // network error
          toast.error(error.message, {
            position: toast.POSITION.TOP_RIGHT,
            toastId: 'errorMsg',
            autoClose: 8000,
          })
        } else {
          // credentils error
          toast.error(error.response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            toastId: 'errorMsg1',
            autoClose: 8000,
          })
        }
      })
  }

  return (
    <div
      className="login d-flex justify-content-center align-items-center"
      style={{ height: '100vh' }}
    >
      <div className="container">
        <div className="card logincard">
          <div className="row g-0">
            <div className="col-md-6">
              <img
                src={img}
                alt="logo"
                style={{ height: '2rem' }}
                className="mt-3"
              />
              <div className="h-100 d-flex justify-content-center align-items-center ">
                <form onSubmit={submit} className="w-100">
                  <div className="py-4 px-3  w-75">
                    <h4>Sign In</h4>
                    <div className="row g-2 mt-1">
                      <div className="col-md-12 mb-2">
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="role"
                          onChange={handleChange}
                          value={data.role}
                          required
                        >
                          <option selected disabled value="">
                            Select Role
                          </option>
                          <option value="Admin">Admin</option>
                          <option value="HR">HR</option>
                          <option value="Accounts">Accounts</option>
                        </select>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-12 mb-2">
                        <div className="mb-2">
                          <input
                            type="email"
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Email"
                            name="email"
                            onChange={handleChange}
                            value={data.email}
                            ref={email}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-md-12 input-group">
                        <input
                          type={showPassword ? 'text' : 'password'}
                          className="form-control"
                          style={{ width: '240px' }}
                          name="password"
                          placeholder="Password"
                          onChange={handleChange}
                          value={data.password}
                          autoComplete="on"
                          required
                        />

                        <span
                          className="input-group-text"
                          style={{ cursor: 'pointer' }}
                          onMouseDown={onMouseDown}
                          onMouseUp={onMouseDown}
                        >
                          {showPassword ? (
                            <AiOutlineEyeInvisible />
                          ) : (
                            <AiOutlineEye />
                          )}
                        </span>
                      </div>
                    </div>

                    <div className="mt-2 d-flex justify-content-between w-100">
                      <button className="btn btn-primary" type="submit">
                        Sign In
                      </button>
                      <Link to="/forgotpassword" className="link">
                        <button
                          className="btn btn-outline-primary"
                          type="button"
                        >
                          Forgot Password ?
                        </button>
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-md-6">
              <div className="right-side-content">
                <div className="content d-flex flex-column">
                  <h1>
                    Welcome <br />
                    To Intranet.
                  </h1>
                </div>
                <div className="right-side">
                  <span></span> <span></span> <span></span> <span></span>
                  <span></span> <span></span> <span></span> <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="parallelogram">
          <span></span> <span></span> <span></span>
        </div>
      </div>
    </div>
  )
}
